<div matDialogTitle class="flex justify-start items-center px-4 border-b-1 border-[var(--mat-sys-surface-variant)]">
    <h3 class="font-semibold">{{ 'CONFIRM' | translate }}</h3>
    <span class="fx-grow-1"></span>
    <button mat-icon-button [matDialogClose]="false" tabindex="-1">
        <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
    </button>
</div>

<div matDialogContent>
    <div class="text-lg font-semibold pb-6">
        {{ message || 'DELETEMESSAGE' | translate }}
    </div>
</div>
<mat-dialog-actions align="end" class="p-3">
    <button (click)="onNo()" color="warn" mat-raised-button tabindex="-1">
        {{ 'NO' | translate }}
    </button>
    <button (click)="onYes()" color="primary" mat-raised-button tabindex="2">
        {{ 'YES' | translate }}
    </button>
</mat-dialog-actions>
